import { useTransform, MotionValue, motion } from "motion/react";
import { useMemo } from "react";

export const HighlightingIcon = ({
    index,
    icon,
    scrollYProgress,
    total,
    onClick,
  }: {
    icon: string;
    scrollYProgress: MotionValue<number>;
    index: number;
    total: number;
    onClick: (idx: number) => void;
  }) => {
    const transparent = "rgb(0, 0, 0 / 0)";
    const cream20 = useMemo(
      () =>
        `rgb(${window
          .getComputedStyle(document.body)
          .getPropertyValue("--brand-cream")} / .2)`,
      []
    );
  
    const mappedProgress = useTransform(
      () => scrollYProgress.get() * (total + 1)
    );
  
    const background = useTransform(
      mappedProgress,
      [index, index + 1, index + 2],
      [transparent, cream20, transparent]
    );
  
    const opacity = useTransform(
      mappedProgress,
      [index, index + 1, index + 2],
      [0.5, 1, 0.5]
    );
  
    return (
      <motion.button
        onClick={() => onClick(index)}
        className="group mb-10 dsk:mt-5 w-10 h-10 rounded-lg flex items-center justify-center cursor-pointer"
        style={{ background }}
        tabIndex={-1}
      >
        <motion.img
          src={icon}
          aria-hidden
          alt=""
          className="w-6 h-6 grayscale"
          style={{ opacity }}
        />
      </motion.button>
    );
  };
